import { useTranslation } from "react-i18next";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { FunctionComponent } from "react";
import CustomCard from "../../../../components/custom-card/CustomCard";
import CustomList from "../../../../components/custom-list/CustomList";

type DetailSettingsProps = {
  openModal?: () => void;
};

const DetailSettings: FunctionComponent<DetailSettingsProps> = ({
  openModal,
}) => {
  const { t } = useTranslation();
  return (
    <div className="wrapper-settings--info mt-3">
      <CustomCard
        title={
          <>
            <div className="card-heading--info mt-2">
              <Typography.Title level={5}>{t("Cài đặt bảo mật", "Cài đặt bảo mật")}</Typography.Title>
            </div>
            <Typography.Text className="sub-title">
              Giữ bí mật thông tin bảo mật của bạn để đảm bảo an toàn cho tài
              khoản của bạn{" "}
            </Typography.Text>
          </>
        }
        className="card-info--wrapper"
      >
        <CustomList
          title={t("Mật khẩu", "Mật khẩu")}
          actions={
            <Button className="btn btn-outlined" onClick={openModal}>
              <SearchOutlined />
              <Typography.Text>{t("Đổi mật khẩu", "Đổi mật khẩu")}</Typography.Text>
            </Button>
          }
        />
        {/* <CustomList title={t("Đặt lại mật khẩu", "Đặt lại mật khẩu")} actions={<Button className="btn btn-outlined">
                    <SyncOutlined/>
                    <Typography.Text>
                        {t("Đặt lại mật khẩu", "Đặt lại mật khẩu")}
                    </Typography.Text>
                </Button>}/> */}
        {/* <CustomList title={t("Bảo mật 2 lớp", "Bảo mật 2 lớp")} actions={<Button className="btn btn-outlined">
                    <SettingOutlined />
                    <Typography.Text>
                        {t("Thiết lập", "Thiết lập")}
                    </Typography.Text>
                </Button>}/>
                <CustomList title={t("Mã bảo vệ", "Mã bảo vệ")} actions={<Button className="btn btn-outlined">
                    <SettingOutlined />
                    <Typography.Text>
                        {t("Thiết lập", "Thiết lập")}
                    </Typography.Text>
                </Button>}/> */}
      </CustomCard>
    </div>
  );
};

export default DetailSettings;
